import React from "react";

/*
 * Main
 */

export const PageIcon = (): React.ReactElement => {
    return (
        <svg
            className="page-icon"
            fill="currentColor"
            height="100"
            viewBox="0 0 16 19"
            width="100"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M14.9 5.37279L9.9 0.372786C9.78333 0.25612 9.625 0.189453 9.45833 0.189453H3.625C1.9 0.189453 0.5 1.58945 0.5 3.31445V14.9811C0.5 16.7061 1.9 18.1061 3.625 18.1061H11.9583C13.6833 18.1061 15.0833 16.7061 15.0833 14.9811V5.81445C15.0833 5.64779 15.0167 5.48945 14.9 5.37279ZM10.0833 2.32279L12.95 5.18945H10.0833V2.32279ZM11.9583 16.8561H3.625C2.59167 16.8561 1.75 16.0145 1.75 14.9811V3.31445C1.75 2.28112 2.59167 1.43945 3.625 1.43945H8.83333V5.81445C8.83333 6.15612 9.11667 6.43945 9.45833 6.43945H13.8333V14.9811C13.8333 16.0145 12.9917 16.8561 11.9583 16.8561ZM3.83333 5.81445C3.83333 5.47279 4.11667 5.18945 4.45833 5.18945H6.125C6.46667 5.18945 6.75 5.47279 6.75 5.81445C6.75 6.15612 6.46667 6.43945 6.125 6.43945H4.45833C4.11667 6.43945 3.83333 6.15612 3.83333 5.81445ZM11.75 9.14779C11.75 9.48945 11.4667 9.77279 11.125 9.77279H4.45833C4.11667 9.77279 3.83333 9.48945 3.83333 9.14779C3.83333 8.80612 4.11667 8.52279 4.45833 8.52279H11.125C11.4667 8.52279 11.75 8.80612 11.75 9.14779ZM11.75 12.4811C11.75 12.8228 11.4667 13.1061 11.125 13.1061H4.45833C4.11667 13.1061 3.83333 12.8228 3.83333 12.4811C3.83333 12.1395 4.11667 11.8561 4.45833 11.8561H11.125C11.4667 11.8561 11.75 12.1395 11.75 12.4811Z" />
        </svg>
    );
};
